import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListView, TypeComparaison, TypeFilter} from "@domain/common/list-view";
import {Adresse, AdresseListItem} from "@domain/profil/adresse";
import {LieuParam} from "@domain/common/lieu/lieu-param";
import {TranslateService} from "@ngx-translate/core";
import {LieuxRecentsListItemComponent} from "@components/lieu/selection/lieux-recents/lieux-recents-list-item.component";

/**
 * Composant d'affichage des lieux récents avec filtres
 */
@Component({
    host: {'data-test-id': 'lieux-recents'},
    selector: 'lieux-recents',
    templateUrl: './lieux-recents.component.html'
})
export class LieuxRecentsComponent implements OnInit {
    /** Paramétrage du lieu */
    @Input() lieuParam: LieuParam;

    /** Event émis lors de la sélection d'une adresse */
    @Output() onAdresseSelect = new EventEmitter<Adresse>();

    /** Liste des lieux récents */
    listeLieuxRecents: ListView<AdresseListItem, LieuxRecentsListItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     */
    constructor(
        private translateService: TranslateService,
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Initialisation de la liste des lieux récents
        this.listeLieuxRecents = new ListView<AdresseListItem, LieuxRecentsListItemComponent>({
            uri: this.lieuParam.urlLieuxRecents,
            title: this.translateService.instant('lieu.tabs.lieuxRecents'),
            component: LieuxRecentsListItemComponent,
            emptyMessage: this.translateService.instant('lieu.aucunLieuRecent'),
            listeFilters: [{
                clef: 'rue',
                title: this.translateService.instant('lieu.rue'),
                type: TypeFilter[TypeFilter.STRING],
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                clef: 'ville',
                title: this.translateService.instant('lieu.ville'),
                type: TypeFilter[TypeFilter.STRING],
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                clef: 'codePostal',
                title: this.translateService.instant('lieu.codePostal'),
                type: TypeFilter[TypeFilter.STRING],
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                clef: 'pays',
                title: this.translateService.instant('lieu.pays'),
                type: TypeFilter[TypeFilter.STRING],
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }],
            extraOptions: {
                selectAdresse: (adresse) => this.selectAdresse(adresse)
            }
        });
    }

    /**
     * Sélection d'une adresse dans la liste
     *
     * @param adresse Adresse sélectionnée
     */
    selectAdresse(adresse: Adresse): void {
        //Les lieux récents sont déjà géolocalisés (latitude/longitude présents)
        adresse.isGeolocalisee = adresse.latitude !== 0 || adresse.longitude !== 0;
        this.onAdresseSelect.emit(adresse);
    }
}